import store from '@/store'
import AuthHelper from '@/pages/auth/helpers/AuthHelper'

class AuthStateHelper
{
    checkState(to, redirectCallback, afterCallback)
    {
        afterCallback = afterCallback || function() {}

        let requiresAuth = to.meta.requiresAuth || false

        let isGuest = store.getters['auth/isGuest']

        // redirect to login
        if( requiresAuth && isGuest )
        {
            redirectCallback({name: 'login', params: {skipAuthStateCheck: true}})
            return
        }

        // redirect to home
        if( ! requiresAuth && ! isGuest )
        {
            if( ! isEmpty(_appConfig.client.client_id) ) {
                AuthHelper.alreadyLogged()
            } else {
                redirectCallback({name: 'home', params: {skipAuthStateCheck: true}})
            }

            return
        }

        // for default scenarios - example in case of router hooks next()
        afterCallback()
    }
}

export default new AuthStateHelper()
